/* eslint-disable id-length */
/* eslint-disable max-lines */
import i18next from 'i18next';

import {
  WASH_SCREEN_SET_UP_FIELDS,
  WASH_SUBSTEPS_IDS,
  HOUSE_KEEPING_FIELDS as WASH_HOUSE_KEEPING_FIELDS,
  TIME_RUNNING_FIELDS,
  CHARGING_FIELDS,
  WASH_SUBSTEP_TARGET
} from '#models/business/washStep/constants';
import {
  SPIRIT_CHARGING_FIELDS,
  SPIRIT_SET_UP_FIELDS,
  SPIRIT_SUBSTEPS_IDS,
  SPIRIT_DIPS_FIELDS,
  DIPS_ISR_FIELDS,
  SPIRIT_SUBSTEP_TARGET,
  STILL_RUN_FIELDS
} from '#models/business/spiritStep/constants';
import {
  MASH_SUBSTEPS_IDS,
  MILLING_FIELDS,
  MASH_DETAILS_FIELDS,
  WORT_ANALYSIS_FIELDS,
  HOUSE_KEEPING_FIELDS,
  MASHING_AND_COLLECTION_FIELDS,
  MASH_SUBSTEP_TARGET,
  PEATED_OPTIONS
} from '#models/business/mashStep/constants';
import { MALT_VARIETY_OPTIONS } from '#models/business/mashStep/mashDetails';
import { YEAST_VARIETY_OPTIONS } from '#models/business/mashStep/mashingAndCollectionMoreInfo';
import {
  SPIRIT_REDUCTIONS_SUBSTEPS_IDS,
  SPIRIT_REDUCTIONS_SUBSTEP_TARGET,
  SPIRIT_REDUCTION_CALCULATIONS_FIELDS,
  SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS,
  SPIRIT_REDUCTION_SRWV_FIELDS,
  SPIRIT_REDUCTION_WATER_READINGS_FIELDS
} from '#models/business/spiritReductions/constants';
import {
  FEINTS_SUBSTEPS_IDS,
  FEINTS_SUBSTEP_TARGET,
  FEINT_INITIAL_PAGE_FIELDS,
  FEINT_MAIN_INFO_FIELDS
} from '#models/business/feints/constants';
import {
  CASKS_INFORMATION_FIELDS,
  CASKS_SUBSTEPS_IDS,
  CASKS_SUBSTEP_TARGET
} from '#models/business/caskFillings/constants';
import {
  STATEMENTS_INFORMATION_FIELDS,
  STATEMENTS_SUBSTEPS_IDS,
  STATEMENTS_SUBSTEP_TARGET
} from '#models/business/statements/constants';

i18next.addResources('en', 'Steps', {
  wash: 'Wash',
  mash: 'Mash',
  spirit: 'Spirit'
});

i18next.addResources('en', MASH_SUBSTEP_TARGET, {
  [MASH_SUBSTEPS_IDS.MILLING]: 'Milling & grist analysis',
  [MASH_SUBSTEPS_IDS.MASH_DETAILS]: 'Mash details',
  [MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION]: 'Mashing & collection',
  [MASH_SUBSTEPS_IDS.WORT_ANALYSIS]: 'Wort analysis',
  [MASH_SUBSTEPS_IDS.HOUSE_KEEPING]: 'House keeping'
});

i18next.addResources('en', WASH_SUBSTEP_TARGET, {
  [WASH_SUBSTEPS_IDS.WASH_SCREEN_SET_UP]: 'Wash Set-up',
  [WASH_SUBSTEPS_IDS.WASH_IDS]: 'Wash ID',
  [WASH_SUBSTEPS_IDS.CHARGING]: 'Charging',
  [WASH_SUBSTEPS_IDS.TIME_RUNNING]: 'Time Running',
  [WASH_SUBSTEPS_IDS.TIME_OFF]: 'Time Off',
  [WASH_SUBSTEPS_IDS.DIPS]: 'Dips',
  [WASH_SUBSTEPS_IDS.HOUSE_KEEPING]: 'House Keeping'
});

i18next.addResources('en', SPIRIT_SUBSTEP_TARGET, {
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_SCREEN_SET_UP]: 'Spirit Set-up',
  [SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS]: 'Spirit ID',
  [SPIRIT_SUBSTEPS_IDS.CHARGING]: 'Charging',
  [SPIRIT_SUBSTEPS_IDS.STILL_RUN]: 'Still Run',
  [SPIRIT_SUBSTEPS_IDS.DIP_ISR]: 'DIP I.S.R',
  [SPIRIT_SUBSTEPS_IDS.DIPS]: 'Dips'
});

i18next.addResources('en', FEINTS_SUBSTEP_TARGET, {
  [FEINTS_SUBSTEPS_IDS.INITIAL_PAGE]: 'Initial Page',
  [FEINTS_SUBSTEPS_IDS.MAIN_INFORMATION]: 'Main information'
});

i18next.addResources('en', FEINTS_SUBSTEPS_IDS.INITIAL_PAGE, {
  [FEINT_INITIAL_PAGE_FIELDS.PERIOD_ID]: 'Select a period',
  [FEINT_INITIAL_PAGE_FIELDS.DATE]: 'Date',
  [FEINT_INITIAL_PAGE_FIELDS.OPERATOR]: 'Operator'
});

i18next.addResources('en', FEINTS_SUBSTEPS_IDS.MAIN_INFORMATION, {
  [FEINT_MAIN_INFO_FIELDS.FEINT_TYPE]: 'Select an option',
  [FEINT_MAIN_INFO_FIELDS.DIP]: 'Dip',
  [FEINT_MAIN_INFO_FIELDS.BULK]: 'Bulk',
  [FEINT_MAIN_INFO_FIELDS.TEMP]: 'Temp.',
  [FEINT_MAIN_INFO_FIELDS.IND]: 'Ind.',
  [FEINT_MAIN_INFO_FIELDS.STRENGTH]: 'Strength',
  [FEINT_MAIN_INFO_FIELDS.TCF]: 'T.C.F.',
  [FEINT_MAIN_INFO_FIELDS.CBULK]: 'C/Bulk',
  [FEINT_MAIN_INFO_FIELDS.LALC]: 'L/Alc',
  peated: 'Peated',
  unpeated: 'Unpeated'
});

i18next.addResources('en', SPIRIT_REDUCTIONS_SUBSTEP_TARGET, {
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.INITIAL_PAGE]: 'Initial Page',
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE]: 'SRWV: Spirit',
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE]: 'SRWV: Reduced Spirit',
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS]: 'Calculations',
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.WATER_READINGS]: 'Water Readings'
});

i18next.addResources('en', SPIRIT_REDUCTIONS_SUBSTEPS_IDS.INITIAL_PAGE, {
  [SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS.PERIOD_ID]: 'Select a period',
  [SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS.FILL_ID]: 'Fill ID',
  [SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS.DATE]: 'Date',
  [SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS.OPERATOR]: 'Operator'
});

i18next.addResources('en', SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE, {
  [SPIRIT_REDUCTION_SRWV_FIELDS.DIP_ORIGINAL]: 'Dip',
  [SPIRIT_REDUCTION_SRWV_FIELDS.BULK_ORIGINAL]: 'Bulk',
  [SPIRIT_REDUCTION_SRWV_FIELDS.TEMP_ORIGINAL]: 'Temp.',
  [SPIRIT_REDUCTION_SRWV_FIELDS.IND_ORIGINAL]: 'Ind.',
  [SPIRIT_REDUCTION_SRWV_FIELDS.STRENGTH_ORIGINAL]: 'Strength',
  [SPIRIT_REDUCTION_SRWV_FIELDS.TCF_ORIGINAL]: 'T.C.F.',
  [SPIRIT_REDUCTION_SRWV_FIELDS.CBULK_ORIGINAL]: 'C/Bulk',
  [SPIRIT_REDUCTION_SRWV_FIELDS.LALC_ORIGINAL]: 'L/Alc'
});

i18next.addResources('en', SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE, {
  [SPIRIT_REDUCTION_SRWV_FIELDS.DIP_REDUCED]: 'Dip',
  [SPIRIT_REDUCTION_SRWV_FIELDS.BULK_REDUCED]: 'Bulk',
  [SPIRIT_REDUCTION_SRWV_FIELDS.TEMP_REDUCED]: 'Temp.',
  [SPIRIT_REDUCTION_SRWV_FIELDS.IND_REDUCED]: 'Ind.',
  [SPIRIT_REDUCTION_SRWV_FIELDS.STRENGTH_REDUCED]: 'Strength',
  [SPIRIT_REDUCTION_SRWV_FIELDS.TCF_REDUCED]: 'T.C.F.',
  [SPIRIT_REDUCTION_SRWV_FIELDS.CBULK_REDUCED]: 'C/Bulk',
  [SPIRIT_REDUCTION_SRWV_FIELDS.LALC_REDUCED]: 'L/Alc'
});

i18next.addResources('en', SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS, {
  [SPIRIT_REDUCTION_CALCULATIONS_FIELDS.BULK_X_TCF]: 'Bulk x TCF',
  [SPIRIT_REDUCTION_CALCULATIONS_FIELDS.CBULK_X_STRENGTH]: 'C/Bulk x Strength',
  [SPIRIT_REDUCTION_CALCULATIONS_FIELDS.LALC_CALCULATION]: 'Reduced Bulk',
  [SPIRIT_REDUCTION_CALCULATIONS_FIELDS.MINUS_CBULK]: 'Minus C/Bulk',
  [SPIRIT_REDUCTION_CALCULATIONS_FIELDS.PLUS_9]: 'Plus 9%',
  [SPIRIT_REDUCTION_CALCULATIONS_FIELDS.TOTAL_WATER]: 'Total Water to add',
  [SPIRIT_REDUCTION_CALCULATIONS_FIELDS.NEW_METER_READING]: 'New Meter Reading'
});

i18next.addResources('en', SPIRIT_REDUCTIONS_SUBSTEPS_IDS.WATER_READINGS, {
  [SPIRIT_REDUCTION_WATER_READINGS_FIELDS.READING_BEFORE]: 'Reading Before',
  [SPIRIT_REDUCTION_WATER_READINGS_FIELDS.READING_AFTER]: 'Reading After',
  [SPIRIT_REDUCTION_WATER_READINGS_FIELDS.WATER_USAGE]: 'Water Usage'
});

i18next.addResources('en', CASKS_SUBSTEP_TARGET, {
  [CASKS_SUBSTEPS_IDS.CASK_FILLING_INFORMATION]: 'Cask Filling Information'
});

i18next.addResources('en', CASKS_SUBSTEPS_IDS.CASK_FILLING_INFORMATION, {
  [CASKS_INFORMATION_FIELDS.PERIOD_ID]: 'Period ID',
  [CASKS_INFORMATION_FIELDS.FILL_ID]: 'Fill ID',
  [CASKS_INFORMATION_FIELDS.CASK_FILLING_FILE]: 'File'
});

i18next.addResources('en', STATEMENTS_SUBSTEP_TARGET, {
  [STATEMENTS_SUBSTEPS_IDS.STATEMENT_INFORMATION]: 'Statement Information'
});

i18next.addResources('en', STATEMENTS_SUBSTEPS_IDS.STATEMENT_INFORMATION, {
  [STATEMENTS_INFORMATION_FIELDS.PERIOD_ID]: 'Period ID',
  [STATEMENTS_INFORMATION_FIELDS.PREVIOUS_PERIOD_ID]: 'Previous Period ID',
  [STATEMENTS_INFORMATION_FIELDS.FEINT_PERIOD_ID]: 'Feint Period ID'
});

i18next.addResources('en', MASH_SUBSTEPS_IDS.MILLING, {
  [MILLING_FIELDS.START_DATE_AND_TIME]: 'Start Date and Time',
  [MILLING_FIELDS.FIRST_MALT_BIN_NO]: 'Malt Bin No. 1',
  [MILLING_FIELDS.SECOND_MALT_BIN_NO]: 'Malt Bin No. 2',
  [MILLING_FIELDS.GRIST_ANALYSIS]: 'Grist Analysis',
  [MILLING_FIELDS.HUSK_RATIO]: 'Husk Ratio',
  [MILLING_FIELDS.GRIST_RATIO]: 'Grist Ratio',
  [MILLING_FIELDS.FLOUR_RATIO]: 'Flour Ratio',
  [MILLING_FIELDS.FAILURE]: 'Failure / Issue',
  [MILLING_FIELDS.FIRST_MALT_BIN_PEATED]: 'Select a Type option for the Malt Bin No. 1',
  [MILLING_FIELDS.FIRST_MALT_BIN_PEATED_MANUAL]: 'Custom Type option 1',
  [MILLING_FIELDS.SECOND_MALT_BIN_PEATED]: 'Select a Type option for the Malt Bin No. 2',
  [MILLING_FIELDS.SECOND_MALT_BIN_PEATED_MANUAL]: 'Custom Type option 2',
  [PEATED_OPTIONS.UNPEATED]: 'Unpeated',
  [PEATED_OPTIONS.PEATED]: 'Peated',
  [PEATED_OPTIONS.HEAVILY_PEATED]: 'Heavily Peated',
  [PEATED_OPTIONS.MANUAL]: 'Manual Option'
});

i18next.addResources('en', MASH_SUBSTEPS_IDS.MASH_DETAILS, {
  [MASH_DETAILS_FIELDS.MASH_ID]: 'Mash ID',
  [MASH_DETAILS_FIELDS.FILL_ID]: 'Fill ID',
  [MASH_DETAILS_FIELDS.MASH_DATE]: 'Mash Date',
  [MASH_DETAILS_FIELDS.WB_NO]: 'W/B No.',
  [MASH_DETAILS_FIELDS.MALT_WEIGHT]: 'Malt Weight',
  [MASH_DETAILS_FIELDS.FIRST_MALT_WEIGHT_PERCENTAGE]: 'Malt Weight Percentage 1',
  [MASH_DETAILS_FIELDS.SECOND_MALT_WEIGHT_PERCENTAGE]: 'Malt Weight Percentage 2',
  [MASH_DETAILS_FIELDS.MALT_VARIETY]: 'Select a Malt Variety option',
  [MASH_DETAILS_FIELDS.MALT_VARIETY_MANUAL]: 'Custom Malt Variety option',
  [MASH_DETAILS_FIELDS.PEATED]: 'Select a Peated option',
  [MALT_VARIETY_OPTIONS.LAUREATE]: 'Laureate',
  [MALT_VARIETY_OPTIONS.CONCERTO]: 'Concerto',
  [MALT_VARIETY_OPTIONS.GOLDEN_PROMISE]: 'Golden Promise',
  [MALT_VARIETY_OPTIONS.SASSY]: 'Sassy',
  [MALT_VARIETY_OPTIONS.MANUAL]: 'Manual Option',
  [PEATED_OPTIONS.UNPEATED]: 'Unpeated',
  [PEATED_OPTIONS.PEATED]: 'Peated',
  [PEATED_OPTIONS.HEAVILY_PEATED]: 'Heavily Peated',
  [PEATED_OPTIONS.MANUAL]: 'Manual Option',
  [MASH_DETAILS_FIELDS.PEATED_MANUAL]: 'Custom Peated option'
});

i18next.addResources('en', MASH_SUBSTEPS_IDS.WORT_ANALYSIS, {
  [WORT_ANALYSIS_FIELDS.WORT_DIP]: 'Dip',
  [WORT_ANALYSIS_FIELDS.WORT_LITRES]: 'Litres (Volume)',
  [WORT_ANALYSIS_FIELDS.WORT_TEMP]: 'Temp',
  [WORT_ANALYSIS_FIELDS.ORIGINAL_GRAVITY]: 'O.G (Saccharometer)',
  [WORT_ANALYSIS_FIELDS.MTE]: 'M.T.E',
  [WORT_ANALYSIS_FIELDS.PSY]: 'P.S.Y',
  [WORT_ANALYSIS_FIELDS.WASHBACK_SEALED]: 'Washback Sealed'
});

i18next.addResources('en', MASH_SUBSTEPS_IDS.HOUSE_KEEPING, {
  [HOUSE_KEEPING_FIELDS.WORTS_LINE_FLOWRATE]: 'Worts Line Flowrate',
  [HOUSE_KEEPING_FIELDS.PROCESS_WATER_METER_READING]: 'Process Water Meter Reading',
  [HOUSE_KEEPING_FIELDS.CAUSTIC_CLEANED]: 'Caustic Cleaned',
  [HOUSE_KEEPING_FIELDS.END_VOLUME_OF_CAUSTIC]: 'End volume of Caustic',
  [HOUSE_KEEPING_FIELDS.MASH_TUN_OPERATOR]: 'Operator',
  [HOUSE_KEEPING_FIELDS.MASH_TUN_NOTES]: 'Notes',
  lineCleaningAndWaterReading: 'Line Cleaning & Water Reading',
  mashTunCleaning: 'Mash Tun Cleaning'
});

i18next.addResources('en', MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION, {
  waterNo: 'Water No.',
  HTLTemp: 'HTL Temp',
  spoutTemp: 'Spout Temp',
  litres: 'Litres',
  timeMashInSpargeOn: 'Time Mash In / Sparge on',
  settlingTime: 'Settling Time',
  recirculationTime: 'Recirculation Time',
  startDrainTime: 'Start Drain Time',
  timeDrained: 'Time Drained',
  first: '1st',
  second: '2nd',
  third: '3rd',
  [MASHING_AND_COLLECTION_FIELDS.YEAST_MANAGEMENT]: 'Yeast Management',
  [MASHING_AND_COLLECTION_FIELDS.YEAST_PITCHED_TIME]: 'Yeast Pitched Time',
  [MASHING_AND_COLLECTION_FIELDS.DRAFF_OUT_START_TIME]: 'Draff out Start Time',
  [MASHING_AND_COLLECTION_FIELDS.FAILURE]: 'Failure / Issue',
  [YEAST_VARIETY_OPTIONS.DISTILAMAX]: 'Distilamax MW',
  [YEAST_VARIETY_OPTIONS.SAFSPIRIT_M1]: 'Safspirit M-1',
  [YEAST_VARIETY_OPTIONS.SAFSPIRIT_D53]: 'Safspirit D-53',
  [YEAST_VARIETY_OPTIONS.MANUAL]: 'Manual',
  [MASHING_AND_COLLECTION_FIELDS.FIRST_YEAST_VARIETY]: 'First Yeast Variety',
  [MASHING_AND_COLLECTION_FIELDS.SECOND_YEAST_VARIETY]: 'Second Yeast Variety',
  [MASHING_AND_COLLECTION_FIELDS.FIRST_YEAST_VARIETY_MANUAL]: 'Custom First Yeast Variety',
  [MASHING_AND_COLLECTION_FIELDS.SECOND_YEAST_VARIETY_MANUAL]: 'Custom Second Yeast Variety',
  [MASHING_AND_COLLECTION_FIELDS.FIRST_YEAST_WEIGHT]: 'First Yeast Weight',
  [MASHING_AND_COLLECTION_FIELDS.SECOND_YEAST_WEIGHT]: 'Second Yeast Weight'
});

i18next.addResources('en', WASH_SUBSTEPS_IDS.WASH_SCREEN_SET_UP, {
  [WASH_SCREEN_SET_UP_FIELDS.WASH_RUN_DATE_AND_TIME]: 'Wash Run Date and Time',
  [WASH_SCREEN_SET_UP_FIELDS.PERIOD_ID]: 'Period ID',
  [WASH_SCREEN_SET_UP_FIELDS.MASH_ID]: 'Mash ID',
  [WASH_SCREEN_SET_UP_FIELDS.MASH_COMPLETE_DATE_AND_TIME]: 'Mash Complete Date and Time',
  [WASH_SCREEN_SET_UP_FIELDS.WASHBACK_NO]: 'Washback No.',
  [WASH_SCREEN_SET_UP_FIELDS.WASHBACK_TEMP]: 'Washback Temp',
  [WASH_SCREEN_SET_UP_FIELDS.WASH_SAMPLE_TEMP]: 'Sample Temp',
  [WASH_SCREEN_SET_UP_FIELDS.FINAL_GRAVITY]: 'F.G (Saccharometer)',
  [WASH_SCREEN_SET_UP_FIELDS.FERMENTATION_TIME]: 'Fermentation Time'
});

i18next.addResources('en', WASH_SUBSTEPS_IDS.WASH_IDS, {
  washStillNo: 'Wash Still No.',
  washId: 'Wash ID'
});

i18next.addResources('en', WASH_SUBSTEPS_IDS.CHARGING, {
  dateAndTimeCharged: 'Date and Time Charged',
  volumeCharged: 'Volume Charged',
  [CHARGING_FIELDS.VALVES_CLOSED]: 'Valves Closed'
});

i18next.addResources('en', WASH_SUBSTEPS_IDS.TIME_RUNNING, {
  [TIME_RUNNING_FIELDS.DATE_AND_TIME_RUNNING]: 'Date and Time Running'
});

i18next.addResources('en', WASH_SUBSTEPS_IDS.TIME_OFF, {
  dateAndTimeOff: 'Date and Time Off',
  temperature: 'Temperature',
  hydrometerReading: 'Hydrometer Reading'
});

i18next.addResources('en', WASH_SUBSTEPS_IDS.HOUSE_KEEPING, {
  causticCleaned: 'Caustic Cleaned',
  operator: 'Operator',
  [WASH_HOUSE_KEEPING_FIELDS.NOTES]: 'Notes'
});

i18next.addResources('en', SPIRIT_SUBSTEPS_IDS.SPIRIT_SCREEN_SET_UP, {
  [SPIRIT_SET_UP_FIELDS.SPIRIT_RUN_DATE_AND_TIME]: 'Spirit Run Date and Time',
  [SPIRIT_SET_UP_FIELDS.PERIOD_ID]: 'Period ID',
  [SPIRIT_SET_UP_FIELDS.MASH_ID]: 'Mash ID',
  [SPIRIT_SET_UP_FIELDS.WASH_ID]: 'Wash ID',
  [SPIRIT_SET_UP_FIELDS.LWFR_VOLUME]: 'LWFR Volume'
});

i18next.addResources('en', SPIRIT_SUBSTEPS_IDS.SPIRIT_IDS, {
  spiritId: 'Spirit ID'
});

i18next.addResources('en', SPIRIT_SUBSTEPS_IDS.CHARGING, {
  dateAndTimeCharged: 'Date and Time Charged',
  volumeCharged: 'Volume Charged',
  [SPIRIT_CHARGING_FIELDS.VALVES_CLOSED]: 'Valves Closed'
});

i18next.addResources('en', SPIRIT_SUBSTEPS_IDS.STILL_RUN, {
  time: 'Time',
  temperature: 'Temperature',
  hydrometerReading: 'Hydrometer Reading',
  [STILL_RUN_FIELDS.TIME_ON_SPIRIT]: 'Time On Spirit',
  [STILL_RUN_FIELDS.TIME_OFF_SPIRIT]: 'Time Off Spirit',
  [STILL_RUN_FIELDS.TIME_STILL_OFF]: 'Time Still Off',
  [STILL_RUN_FIELDS.FORESHOTS_START_TIME]: 'Foreshots Start Time'
});

i18next.addResources('en', SPIRIT_SUBSTEPS_IDS.DIP_ISR, {
  [DIPS_ISR_FIELDS.DIP_ISR_HEIGHT]: 'Dip I.S.R Height',
  [DIPS_ISR_FIELDS.DIP_ISR_VOLUME]: 'Dip I.S.R Volume',
  ISRSubtitle: 'ISR to SRWV transfer',
  [DIPS_ISR_FIELDS.ISR_TRANSFERRED]: 'Transferred',
  [DIPS_ISR_FIELDS.ISR_VOLUME_TRANSFERRED]: 'Volume Transferred',
  [DIPS_ISR_FIELDS.ISR_OPERATOR]: 'Operator'
});

i18next.addResources('en', SPIRIT_SUBSTEPS_IDS.DIPS, {
  [SPIRIT_DIPS_FIELDS.LWFR_DIP_HEIGHT]: 'LWFR DIP Height',
  [SPIRIT_DIPS_FIELDS.LWFR_DIP_VOLUME]: 'LWFR DIP Volume'
});

i18next.addResources('en', 'AdelphiStatementsSpiritAndFeints', {
  previousRemnant: 'Previous Remnant',
  srwv: 'SRWV {{fillId}}',
  remnant: 'Remnant {{fillId}}',
  dip: 'Dip',
  bulk: 'Bulk',
  lwfr: 'LWFR',
  dillutedSpirit: 'Diluted Spirit',
  totalLossGain: 'Total Loss/Gain'
});

i18next.addResources('en', 'checklist', {
  operator: 'Operator',
  operatorAM: 'Operator AM',
  operatorPM: 'Operator PM',
  date: 'Date',
  comment: 'Comment',
  shiftHandoverComments: 'Shift handover comments',
  sumpPumpOff: 'Sump pump off',
  potAleTankCheckedAndPumpOffUnlessFull: 'Pot Ale tank checked and pump off unless full',
  spentLeesTankLevelCheck: 'Spent Lees tank level check',
  watermiserOff: 'Watermiser off',
  watermiserImmersorOnWinterOnlyForecastBelow0: 'Watermiser immersor on (winter only; forecast below 0)',
  upperStillhouseFloorClean: 'Upper stillhouse floor clean',
  lowerStillhouseFloorClean: 'Lower stillhouse floor clean',
  boilerHouseLocked: 'Boiler house locked',
  spiritTransferred: 'Spirit transferred',
  washStillBlueHosed: 'Wash Still blue hosed',
  spiritStillBlueHosed: 'Spirit Still blue hosed',
  sumpPumpOn: 'Sump pump on',
  potAlePumpOnOnceRecircToBelow50Degrees: 'Pot Ale pump on (once recirc to below 50 degrees)',
  watermiserOnAndCheckBromineLevel: 'Watermiser on and check bromine level',
  watermiserImmersorOffWinterOnlyForecastBelow0: 'Watermiser immersor off (winter only; forecast below 0)',
  boilerBlowDownDone: 'Boiler blow down done',
  accumulatorBlowDownDone: 'Accumulator blow down done',
  boilerHouseClean: 'Boiler house clean',
  sinkClean: 'Sink Clean',
  deskAreaClean: 'Desk Area Clean',
  yeastAreaClean: 'Yeast Area Clean',
  washbacksHosedDown: 'Washbacks Hosed down',
  underfloorHosed: 'Underfloor Hosed',
  upperFloorClean: 'Upper floor clean',
  mashTunHosedDown: 'Mash tun hosed down',
  outsideDraffAreaSweptClean: 'Outside draff area swept clean',
  millhouseSweptClean: 'Millhouse swept clean',
  draffTrailerInPositionReadyForNextShift: 'Draff trailer in position ready for next shift',
  checkLevelOfBlackWaterTanksSummerOnly: 'Check level of Black Water tanks (summer only)',
  bannistersClean: 'Bannisters clean',
  checkDustBagHoppers: 'Check dust bag hoppers',
  checkAndCleanProcessWaterFilterUnderHlt1: 'Check and clean process water filter under HLT 1',
  outsideBinTuesdayMorningsBefore9Am: 'Outside bin (Wednesday mornings before 9am)',
  houseUnderMaltSilos: 'Hose under malt silos',
  hooverMillHouseMezLevel: 'Hoover mill house mez level',
  floorMopped: 'Floor mopped',
  cleanYellowYeastBuckets: 'Clean yellow yeast buckets',
  intermediatePotAleTankHosedOut: 'Intermediate Pot Ale tank hosed out',
  productionDoors: 'Production doors',
  waterSupplyUvCabinetsCourtyardAndBar: 'Water supply UV cabinets (courtyard and bar)',
  stillhouseWindowsCleaned: 'Stillhouse windows cleaned',
  polishLids: 'Polish Lids',
  polishSpiritSafe: 'Polish Spirit Safe',
  productionBins: 'Production bins',
  emptyDustyBagFromBin: 'Empty dust bag from within Bin',
  cleanDustExtractionCycloneLastWeekOfMonth: 'Clean Dust extraction Cyclone last week of month'
});
